import { render, staticRenderFns } from "./FavouritesCartButton.vue?vue&type=template&id=3da5272a&scoped=true&"
import script from "./FavouritesCartButton.vue?vue&type=script&lang=js&"
export * from "./FavouritesCartButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da5272a",
  null
  
)

export default component.exports